import Vuex from "vuex";
import Vue from "vue";
import userStore from "@/store/user";
import teacherStore from "@/store/teacher";
import klassStore from "@/store/klass";
import commonStore from "@/store/common";

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        userStore,
        teacherStore,
        klassStore,
        commonStore,
    },
});
